import { useForm, Controller } from "react-hook-form";
import Filter from "./Filter"
import { Autocomplete, Box, TextField } from "@mui/material";
export const FilterService = ({ onFilter, classifications }) => {

    const pets = classifications?.pets || [];
    const services = classifications?.services || [];
    const owners = classifications?.owners || [];

    const defaultValues = {
        id: "",
        pet_id: "",
        owner_id: "",
        service_id: "",
        start_date: "",
        end_date: "",
    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                <TextField
                    id="id"
                    label="Id"
                    variant="outlined"
                    name="id"
                    {...methods.register("id")}
                />

                <Controller
                    name="pet_id"
                    control={methods.control}
                    render={({ field }) => {
                        const petOptions = pets.map(pet => ({
                            label: pet.name,
                            value: pet.id
                        }));
                        const selectedPet = petOptions.find(option => option.value === field.value);
                        
                        return (
                            <Autocomplete
                                value={selectedPet || null}
                                options={petOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Pet" />}
                            />
                        );
                    }}
                />

                <Controller
                    name="owner_id"
                    control={methods.control}
                    render={({ field }) => {
                        const ownerOptions = owners.map(owner => ({
                            label: owner.name,
                            value: owner.id
                        }));
                        const selectedOwner = ownerOptions.find(option => option.value === field.value);
                        
                        return (
                            <Autocomplete
                                value={selectedOwner || null}
                                options={ownerOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Dono" />}
                            />
                        );
                    }}
                />

                <Controller
                    name="service_id"
                    control={methods.control}
                    render={({ field }) => {
                        const serviceOptions = services.map(service => ({
                            label: service.name,
                            value: service.id
                        }));
                        const selectedService = serviceOptions.find(option => option.value === field.value);
                        
                        return (
                            <Autocomplete
                                value={selectedService || null}
                                options={serviceOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Serviço" />}
                            />
                        );
                    }}
                />

                <TextField
                    id="start_date"
                    label="Data de Início"
                    type="date"
                    variant="outlined"
                    name="start_date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    {...methods.register("start_date")}
                />

                <TextField
                    id="end_date"
                    label="Data de Fim"
                    type="date"
                    variant="outlined"
                    name="end_date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    {...methods.register("end_date")}
                />

            </Box>
        </Filter>

    )
}